import { inject, observer } from "mobx-react";
import AgGrid from "../../../common/components/ag-grid/ag-grid";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RestEndPoint from "../../../common/RestEndPoint";
import {
  faPlus,
  faSave,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import {
  DecimalFormatter4DigitsWithoutSymbol, DecimalFormatter2Digits
} from "../../../common/NumberFormatter";
import userRoles from '../../../constants/userRoles';
import { NGLSpotPriceConst } from '../../../constants/nglSpotPrice'
import { NGLTowerTargetsConst } from '../../../constants/nglTowerTargets'
import SmartSelect from "../../../common/SmartSelect";

import './spot-price-tower-targets.scss';

@inject("NGLSpotPriceAndTowerTargetsDataStore")
@observer
class NGLSpotPriceAndTowerTargets extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gridOptions: {
        newRowNotSaved: false,
        rowSelection: "multiple",
        singleClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        enableRangeSelection: true,
        rowGroupPanelShow: "always",
        suppressContextMenu: true,
        getRowStyle: this.getRowStyleScheduled,
        statusBar: {
          statusPanels: [
            {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left",
            },
            {
              statusPanel: "agAggregationComponent",
              statusPanelParams: {
                aggFuncs: ["avg", "count", "min", "max", "sum"],
              },
            },
          ],
        },
        sideBar: {
          toolPanels: [
            {
              id: "columns",
              labelDefault: "Columns",
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
            },
          ],
          showToolPanel: false,
        },
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true,
          cellStyle: (param) => {
            if (this.isOverflow(param) === true) return { overflow: "visible" };
          },
        },
        frameworkComponents: {
          SmartSelectClearable: SmartSelect,
          decimalFormatter2Digits: DecimalFormatter2Digits,
          decimalFormatter4DigitsWithoutSymbol: DecimalFormatter4DigitsWithoutSymbol, //for 3 digits round off materiality)

        },
      },
      selectedData: [],
    };
  }

  isOverflow(params) {
    if (params.colDef.field === "IsActive") {
      return true;
    } else return false;
  }

  setColumnDef = async () => {
    const { CommonStore, NGLSpotPriceAndTowerTargetsDataStore } = this.props;
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    await NGLSpotPriceAndTowerTargetsDataStore.setColumnDef(currentScreen, CommonStore);
  };

  getCurrentScreenChildren = () => {
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreenChildren = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.parent === parentScreenName
    );
    return currentScreenChildren;
  };

  getProductData = async () => {
    const currentScreen = this.getCurrentScreen();
    const { NGLSpotPriceAndTowerTargetsDataStore } = this.props;
    await NGLSpotPriceAndTowerTargetsDataStore.getProductsData(currentScreen);
  };

  getData = async () => {
    const currentScreen = this.getCurrentScreen();
    const { CommonStore, NGLSpotPriceAndTowerTargetsDataStore } = this.props;
    const isReadOnly = RestEndPoint.checkCurrentUserHasRole(this.getCurrentScreenName() === NGLSpotPriceConst.NGLSpotPrice?userRoles.SpotPriceReadOnly:userRoles.TowerTargetsReadOnly)
    await NGLSpotPriceAndTowerTargetsDataStore.getScreenData(currentScreen, CommonStore, isReadOnly);
  };

  getKeyColumnName = () => {
    const { screenColumns } = this.getCurrentScreen();
    const keyColumn = screenColumns.find((x) => x.isKey);
    let keyColumnName = keyColumn ? keyColumn.name : "ID";
    return keyColumnName;
  };

  selectNode(nodeIndex) {
    let node = this.state.gridOptions.api.getDisplayedRowAtIndex(nodeIndex);
    node.setSelected(true);
  }

  addNewRow = async () => {
    const { NGLSpotPriceAndTowerTargetsDataStore } = this.props;
    NGLSpotPriceAndTowerTargetsDataStore.isEditable = true;
    this.setState({ newRowNotSaved: true });
    const keyColumnName = this.getKeyColumnName();
    let newRowData = {};
    this.props.NGLSpotPriceAndTowerTargetsDataStore.screenColumnDefinitions[this.getCurrentScreenName()].forEach((col) => {
      col.isEditableCol = false;
      newRowData[col.field] = null;
    });

    newRowData.isNewRow = true;
    newRowData[keyColumnName] = 0;

    if (this.getCurrentScreenName() === NGLSpotPriceConst.NGLSpotPrice) {
      newRowData[NGLSpotPriceConst.SpotPrice_USD] = 0.0000;
      newRowData[NGLSpotPriceConst.Conversion_Factor] = 0.0000;
    }

    if (this.getCurrentScreenName() === NGLTowerTargetsConst.NGLTowerTargets) {
      newRowData[NGLTowerTargetsConst.Target_Value] = 0.00;
      newRowData[NGLTowerTargetsConst.Min_Value] = 0.00;
      newRowData[NGLTowerTargetsConst.Max_Value] = 0.00;
    }

    const { gridOptions } = this.state;
    gridOptions.api.insertItemsAtIndex(0, [newRowData]);
    let cols = gridOptions.columnApi.getAllDisplayedColumns();
    const NonPinnedColumn = cols.filter((x) => !x.pinned);
    gridOptions.api.ensureColumnVisible(NonPinnedColumn[0]);
    gridOptions.api.startEditingCell({
      rowIndex: 0,
      colKey:
        gridOptions.columnApi.getDisplayedCenterColumns()[0].colId,
    });
    this.setState({ rowIndex: 1 });
    gridOptions.api.ensureColumnVisible(NonPinnedColumn[0]);
    this.selectNode(0);
  };

  getCurrentScreen = () => {
    const screenName = this.props.path.split("/").pop();
    const currentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === screenName
    );
    return currentScreen;
  };

  getCurrentScreenName = () => {
    let currentScreen = this.getCurrentScreen()
    return currentScreen.screen.name === NGLSpotPriceConst.NGLSpotPrice ? NGLSpotPriceConst.NGLSpotPrice : NGLTowerTargetsConst.NGLTowerTargets;
  };
 
  render() {
    const {
      rowData,
      screenColumnDefinitions,
      SpotPriceReadOnly,
      TowerTargetsReadOnly
    } = this.props.NGLSpotPriceAndTowerTargetsDataStore;
    const parentScreen = this.getCurrentScreenParent();
    let colDef = screenColumnDefinitions[this.getCurrentScreenName()];
    const { selectedData } =
      this.props.NGLSpotPriceAndTowerTargetsDataStore;
    return (
      <div className="wrapper">
        <div className="row">
          <div className="col-md-12">
            <div className="container cb-title-container">
              <h3 className="cb-title">{parentScreen.screen.title}</h3>
            </div>

            <div className="row">
              {rowData && (
                <AgGrid
                  gridID={this.getCurrentScreenName()}
                  gridOptions={this.state.gridOptions}
                  columnDefs={colDef}
                  rowData={rowData}
                  onCellValueChanged={this.onCellValueChanged.bind(this)}
                />
              )}
            </div>
            <div className="row btn-toolbar pull-right">
              {(this.getCurrentScreenName()===NGLSpotPriceConst.NGLSpotPrice ? !SpotPriceReadOnly : !TowerTargetsReadOnly) && (
                <>
                  <button
                    type="add"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    disabled={this.state.newRowNotSaved || selectedData.filter(p => p.ID !== 0).length > 0}
                    onClick={this.addNewRow}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    Add
                  </button>

                  <button
                    type="save"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    onClick={this.saveData}
                    disabled={selectedData == 0}
                  >
                    <FontAwesomeIcon icon={faSave} />
                    Save
                  </button>
                </>
              )}
              <button
                type="refresh"
                className="btn btn-primary btn-grid active"
                aria-expanded="false"
                onClick={this.refreshData}
              >
                <FontAwesomeIcon icon={faSync} />
                Refresh / Cancel
              </button>

            </div>
          </div>
        </div>
      </div>
    );
  }

  saveData = async () => {
    const currentScreen = this.getCurrentScreen();
    const { CommonStore, NGLSpotPriceAndTowerTargetsDataStore } = this.props;
    await NGLSpotPriceAndTowerTargetsDataStore.saveData(currentScreen, CommonStore);

    if (NGLSpotPriceAndTowerTargetsDataStore.dataSaved) {
      NGLSpotPriceAndTowerTargetsDataStore.isEditable = false
      await this.getData();
      this.setState({ newRowNotSaved: false });
    }
  };

  onCellValueChanged = function (e) {
    const currentUser = RestEndPoint.getCurrentUserName();
    const { selectedData } = this.props.NGLSpotPriceAndTowerTargetsDataStore;
    const keyColumnName = this.getKeyColumnName();
    const mstTime = new Date();

    if (e.oldValue != e.newValue) {
      const existingRowIndex = selectedData.findIndex(
        (x) => x[keyColumnName] === e.data[keyColumnName]
      );
      if (
        e.column.colId === "IsActive" &&
        (e.newValue === null || e.oldValue === null)
      ) {
        if (e.oldValue === null && (e.newValue !== null && e.value !== null)) {
          e.node.setDataValue(e.colDef.field, e.newValue);
          e.data["IsActive"] = e.newValue;
        }
        if (e.oldValue !== null && (e.newValue === null && e.value === null)) {
          e.node.setDataValue(e.colDef.field, e.oldValue);
          e.data["IsActive"] = e.oldValue;
        }
        if (existingRowIndex > -1)
          selectedData[existingRowIndex] = e.data;
      }
      else {
        if (e.data["ID"] !== 0) {
          e.data["Updated_By"] = currentUser;
          e.data["Updated_On"] = mstTime;
        }
        else {
          e.data["Created_By"] = currentUser;
          e.data["Created_On"] = mstTime;
        }
        if (existingRowIndex > -1)
          selectedData[existingRowIndex] = e.data;
        else
          selectedData.push(e.data);
        this.state.gridOptions.api.refreshCells();
        if (e.newValue !== null) {
          e.node.setDataValue(e.colDef.field, e.newValue);
          this.state.gridOptions.api.refreshCells();
        } else {
          e.node.setDataValue(e.colDef.field, e.oldValue);
        }
      }
    }
  };


  componentDidMount = async () => {
    await this.setColumnDef();
    await this.refreshData();
    this.getData();
    this.getProductData();
  };
  refreshData = async () => {
    this.props.NGLSpotPriceAndTowerTargetsDataStore.isEditable = false
    this.setState({ newRowNotSaved: false });
    await this.getData();
  };

  getCurrentScreenParent = () => {
    const parentScreenName = this.props.path.split("/").pop();
    const parentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === parentScreenName
    );

    return parentScreen;
  };
}
export default NGLSpotPriceAndTowerTargets;
